import type { CreateChatThreadResponseAllOfCurrentUserStatus } from './createChatThreadResponseAllOfCurrentUserStatus';
import type { CreateChatThreadResponseAllOfParticipantsItem } from './createChatThreadResponseAllOfParticipantsItem';

export type CreateChatThreadResponseAllOf = {
  chatRoomId: number;
  createdAt: string;
  currentUserStatus?: CreateChatThreadResponseAllOfCurrentUserStatus;
  isGroupThread: boolean;
  /** @nullable */
  lastMessage?: string | null;
  /** @nullable */
  lastMessageTime?: string | null;
  participants: CreateChatThreadResponseAllOfParticipantsItem[];
  /** @nullable */
  unreadMessageCount?: number | null;
};
